import { appENV, checkENV } from "./Config";

const rootFolder = appENV === checkENV ? '' : '/digitalportfolio2';
//const rootFolder = '';
export const staticFiles = {
    book: rootFolder + '/static/img/book.png',
    checkedCircle: rootFolder + '/static/img/checked-circle.svg',
    cloud: rootFolder + '/static/img/cloud-upload.png',
    cross: rootFolder + '/static/img/cross-gray-icon.svg',

    coverDefault: rootFolder + '/static/img/default-cover.png',

    loading: rootFolder + '/static/img/loading.gif',

    editLayout: rootFolder + '/static/img/edit-layout-icon.svg',

    more: rootFolder + '/static/img/more-gray-icon.svg',

    nieLogo: rootFolder + '/static/img/logo-white.png',

    // noImage: rootFolder + '/static/img/Image_not_available.jpg',
    noImage: rootFolder + '/static/img/no-image.jpg',

    noProfilePic: rootFolder + '/static/img/no-profile-pic.png',

    paper: rootFolder + '/static/img/paper.png',
    link: rootFolder + '/static/img/link-icon.svg',
    export: rootFolder + '/static/img/export-icon.svg',

    loveRed: rootFolder + '/static/img/love-icon.svg',
    loveGray: rootFolder + '/static/img/love-gray-icon.svg',
    chat: rootFolder + '/static/img/chat-black-icon.svg',

    fileUpload: rootFolder + '/static/img/description-black.svg',
    editIcon: rootFolder + '/static/img/edit_icon.png'

}